module.exports = __webpack_public_path__ + "static/media/Blonde-in-luxury-interior-343621-min.946d0df4.jpg";